import React, { useState } from "react";
import { Download, Eye, RotateCcw } from "lucide-react";

function statusTone(status) {
  if (status === "complete") return "complete";
  if (status === "failed") return "failed";
  if (status === "needs_input") return "needs-input";
  if (status === "generating") return "generating";
  return "pending";
}

function statusLabel(status) {
  const map = {
    complete: "Complete",
    failed: "Failed",
    needs_input: "Needs Input",
    generating: "Generating",
    pending: "Pending",
  };
  return map[status] || status || "Pending";
}

function relativeTime(value) {
  if (!value) return "";
  const date = new Date(value);
  const seconds = Math.max(1, Math.round((Date.now() - date.getTime()) / 1000));
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  return `${days}d ago`;
}

export default function DossierHistory({ dossiers, loading, onView, onDownload, onRetry }) {
  const [expanded, setExpanded] = useState(false);

  if (loading) {
    return (
      <section className="dossier-history">
        <h3>Past Dossiers For This Lead</h3>
        <div className="dossier-skeleton" />
        <div className="dossier-skeleton short" />
      </section>
    );
  }

  if (!dossiers?.length) return null;

  const visible = expanded ? dossiers : dossiers.slice(0, 5);

  return (
    <section className="dossier-history">
      <h3>Past Dossiers For This Lead</h3>
      <div className="dossier-history-list">
        {visible.map((dossier) => (
          <div className="dossier-history-row" key={dossier.id}>
            <div>
              <strong>{dossier.prospect_name}</strong>
              <span>{dossier.product_context || "Generic"} - {relativeTime(dossier.created_at)}</span>
            </div>
            <span className={`dossier-status ${statusTone(dossier.status)}`}>{statusLabel(dossier.status)}</span>
            <div className="dossier-history-actions">
              {dossier.status === "complete" && (
                <>
                  <button className="Soft-Button Small" onClick={() => onView(dossier)}><Eye size={13} /> View</button>
                  <button className="Soft-Button Small" onClick={() => onDownload(dossier.id, dossier.prospect_name)}><Download size={13} /> Download</button>
                </>
              )}
              {(dossier.status === "failed" || dossier.status === "needs_input") && (
                <button className="Soft-Button Small" onClick={() => onRetry(dossier)}><RotateCcw size={13} /> Retry</button>
              )}
              {(dossier.status === "pending" || dossier.status === "generating") && (
                <button className="Soft-Button Small" onClick={() => onView(dossier)}><Eye size={13} /> Status</button>
              )}
            </div>
          </div>
        ))}
      </div>
      {dossiers.length > 5 && (
        <button className="dossier-show-all" onClick={() => setExpanded((value) => !value)}>
          {expanded ? "Show Recent 5" : `Show All ${dossiers.length} Dossiers`}
        </button>
      )}
    </section>
  );
}
